/**
 * Asynchronously loads the component for NotFoundPage
 */
import Loadable from 'ui/Loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "404-page" */ './index'),
});
